module.exports = __webpack_public_path__ + "static/media/frog.977790fe.png";